/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NewAccreditationUpdateAliases {
  CHECKBOX_TERM = 'checkbox-term',
  CONTEXTUAL_BAR_ACCREDITATION_CATEGORIES = 'contextual-bar-accreditation-categories',
  DECK_ACCREDITATION_CATEGORIES = 'deck-accreditation-categories',
  FETCH_0 = 'fetch-0',
  FETCH_ACCREDITATION_CATEGORIES = 'fetch-accreditation-categories',
  FIELD_1 = 'field-1',
  FIELD_ACCREDITATION_CATEGORIES_NAME = 'field-accreditation-categories-name',
  FIELD_CHECKBOX_TERM = 'field-checkbox-term',
  FIELD_PROVIDER = 'field-provider',
  FIELD_TYPE_ACCREDITATION = 'field-type-accreditation',
  FORM_TERM = 'form-term',
  HPMS_CUSTOM_CARD_ACCREDITATION_CATEGORIES = 'hpms-custom-card-accreditation-categories',
  HPMS_TEXT_HTML_TERM = 'hpms-text-html-term',
  MODAL_TERM = 'modal-term',
  PANEL_ACCREDITATION_UPDATE = 'panel-accreditation-update',
  PANEL_TERM = 'panel-term',
  TEXT_3 = 'text-3',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { NewAccreditationUpdateAliases };
